import React from 'react';
import {
  Typography,
  CardBody,
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import NullViewTexts from '../../../constants/NullViewTexts';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../../constants/responsiveClassNames';

const ListsNullView = ({ componentId }) => {

  const { ref, clickID } = useImpression({
    data: {
      component: 'Lists',
      name: 'ListsNullState',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  const {
    cardTitle, benefits, imageAlt, imageUrl
  } = NullViewTexts;

  const cardBody = (
    <CardBody>
      <ul
        className="sui-list-disc sui-list-outside sui-ml-4 sui-mb-0 sui-pb-4"
      >
        {benefits?.map((benefit, index) => (
          <li key={index}>
            <Typography>{benefit}</Typography>
          </li>
        ))}
      </ul>
    </CardBody>
  );

  return (
    <div
      className="sui-@container sui-h-full"
      data-testid="lists-null-view"
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      <div
        id="lists-compact-null-view"
        className={classNames(showBelowSmBreakpoint)}
      >
        <CompactNullView
          cardBody={cardBody}
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          cardTitle={cardTitle}
          clickID={clickID}
        />
      </div>
      <div
        id="lists-desktop-null-view"
        className={classNames(showAboveSmBreakpoint, 'sui-h-full')}
      >
        <DesktopNullView
          cardBody={cardBody}
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          cardTitle={cardTitle}
        />
      </div>
    </div>
  );
};

ListsNullView.propTypes = {
  componentId: PropTypes.string,
};

ListsNullView.defaultProps = {
  componentId: '',
};

export default ListsNullView;
